// function parseLCS(name) {
//   return JSON.parse(localStorage.getItem(name));
// }

const initialState = {
  token: localStorage.getItem("token") ?? "",
  info: localStorage.getItem("info") ?? "",
  user: {},
  users: [],
  arrayTests: [],
  statuses: [],
};

export default initialState;
